// extracted by mini-css-extract-plugin
export var bounce = "_ls-1";
export var generatingText = "_ls-6";
export var lightning = "_ls-4";
export var popup = "_ls-5";
export var progressBar = "_ls-7";
export var progressFill = "_ls-8";
export var progressShimmer = "_ls-9";
export var progressText = "_ls-a";
export var shimmer = "_ls-3";
export var uploadIcon = "_ls-0";
export var uploadingText = "_ls-2";